/**
 * External dependencies
 */
import { useQuery } from '@tanstack/react-query';

/**
 * Internal dependencies
 */

const formatAvailableCountries = (countries) => {
	if (!countries) {
		return '';
	}

	return countries.toString();
};

/**
 * Fetch instances
 * @returns {object}
 */
function useLocalInstances({ id, apiUrl }) {
	const { isPending, isError, data, error, refetch } = useQuery({
		queryKey: ['id'],
		queryFn: async () => {
			const baseUrl = `${apiUrl}/wp-json/visitedu-block-theme/v1/events/${id}/instances`;

			const url = new URL(baseUrl);

			const response = await fetch(url.href);

			return (await response.json()).data || [];
		},
	});

	return {
		data,
		error,
		isError,
		isPending,
		refetch,
	};
}

export { useLocalInstances };
